<template lang="pug">
section
  s-page-title(title='Жилые комплексы')
    template(slot='extension')
      s-sort-button(@click='sorting.opened = true' class='mr-3')
      v-btn(@click='onComplexAdd' color='primary' depressed) Добавить
  v-container(
    v-for='(complexes, region) in groupedList'
    :key='region'
    class='pa-0 mb-5'
    grid-list-xl fluid
  )
    v-layout(row wrap)
      v-flex(xs12 class='title grey--text') {{ region }}
      v-flex(
        v-for='complex in complexes'
        :key='complex.id'
        xs12 sm6 md4 lg3 xl3
      )
        card(
          :complex='complex'
          @click='onComplexShow'
          @edit='onComplexEdit'
          @remove='onComplexRemove'
        )
  s-sorting-list(v-model='sorting' @sort-success='fetch')
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Card from './Card'
import { groupBy } from 'lodash'

export default {
  components: {
    Card
  },

  data: () => ({
    sorting: {
      opened: false,
      resource: 'complexes',
      itemValue: 'id',
      itemText: 'complex_name',
      groupBy: 'region_name'
    }
  }),

  async created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      try {
        await this.fetchList({ config: { params: { show_info: true } } })
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки списка комплексов')
      }
    },

    async onComplexRemove({ id }) {
      if (await this.$confirm('Удалить комплекс?')) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$showServerErrors(e)
        }
      }
    },

    onComplexAdd() {
      this.$router.push({ name: 'Complexes.Edit' })
    },

    onComplexShow({ id }) {
      this.$router.push({
        name: 'Complexes.Objects',
        params: { id }
      })
    },

    onComplexEdit({ id }) {
      this.$router.push({
        name: 'Complexes.Edit',
        params: { id }
      })
    },

    ...mapActions('objects/complexes', ['fetchList', 'destroy'])
  },

  computed: {
    groupedList() {
      return groupBy([...this.list], 'region_name')
    },

    ...mapGetters('objects/complexes', ['isLoading', 'list'])
  }
}
</script>
